import React from 'react';
export default /*#__PURE__*/React.createContext({
  rowIndex: null,
  columnIndex: null
});
//# sourceMappingURL=cell-context.js.map